import React, { Component } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { Badge } from "../ui/badge";
import { userService } from "../../_services";
import Pagination from '../ui/pagination';

/**
 * Referrals List Component
 * Modernized with Shadcn Card and Table components
 */
class Refferals_list extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Referrals: [],
            pageOfItems: []
        };
        this.onChangePage = this.onChangePage.bind(this);
    }

    componentDidMount() {
    }

    onChangePage(pageOfItems) {
        this.setState({ pageOfItems: pageOfItems });
    }

    GetReferralList(UserId, UserName) {
        userService.GetReferralList(UserId, UserName)
            .then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ Referrals: apidata });
                        }
                    }
                    catch (error) {
                        console.error('Error fetching referral list:', error);
                    }
                }
            );
    }

    render() {
        let { pageOfItems } = this.state;
        const dataToDisplay = pageOfItems;

        return (
            <Card>
                <CardHeader>
                    <div className="flex items-center justify-between">
                        <CardTitle className="text-2xl font-bold">Your Referrals</CardTitle>
                        <Badge variant="secondary" className="text-base">
                            Total Referrals: {this.props.Referrals.length}
                        </Badge>
                    </div>
                </CardHeader>
                <CardContent>
                    {this.props.Referrals != null && this.props.Referrals.length > 0 ? (
                        <div className="space-y-4">
                            <div className="rounded-md border">
                                <Table>
                                    <TableHeader>
                                        <TableRow>
                                            <TableHead>User Name</TableHead>
                                            <TableHead>Group Number</TableHead>
                                            <TableHead>Email</TableHead>
                                            <TableHead>Referral Date</TableHead>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {dataToDisplay.map((uitem, _index) => (
                                            <TableRow key={_index + uitem.userName}>
                                                <TableCell className="font-medium">{uitem.userName}</TableCell>
                                                <TableCell>{uitem.groupNumber}</TableCell>
                                                <TableCell>{uitem.email}</TableCell>
                                                <TableCell>{uitem.referralDate}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                            <Pagination items={this.props.Referrals} onChangePage={this.onChangePage} />
                        </div>
                    ) : (
                        <div className="text-center py-12">
                            <p className="text-muted-foreground">No records found</p>
                        </div>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default Refferals_list;
